import type { ReactElement } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../redux/store";

const ContentManagerProtectedRoute = ({ children }: { children: ReactElement }) => {
    const { token } = useSelector((state: RootState) => state.cmAuth);

    if (!token) {
        return <Navigate to="/content-manager/login" replace />;
    }

    return children;
};

export default ContentManagerProtectedRoute;
